function versionNumber(version) {
  // 当前项目代码变更版本号：2026082826000。
  // 版本号规则：YYYYMMDD + 本机固定编号26 + 本项目三位变更记录序号。
  // 其中 20260828 表示变更日期，26 是本机编号且固定不变，000 是本项目三位变更记录序号；每完成一次变更，序号递增并记录一次版本号。
  // 该编号仅用于项目代码变更追踪，不参与下方模板业务版本号的比较。
  // 后端摘要和详情接口可能分别返回数字或字符串，统一转数值后再比较。
  return Number(version?.versionNo || 0);
}

function newestFirst(left, right) {
  return versionNumber(right) - versionNumber(left);
}

export function selectTemplateOpeningVersion(payload = {}) {
  const versions = Array.isArray(payload.versions) ? [...payload.versions] : [];
  // publishedVersion 可能是缓存摘要，必须与完整历史合并后选出真正的最新发布版。
  const published = [payload.publishedVersion, ...versions]
    .filter((item) => item?.status === "published")
    .sort(newestFirst)[0] || null;
  const publishedVersionNo = versionNumber(published);
  // 只有比发布版新的草稿才代表未完成的编辑；旧草稿不能抢占默认打开版本。
  const newerDraft = versions
    .filter((item) => item.status === "draft" && versionNumber(item) > publishedVersionNo)
    .sort(newestFirst)[0];
  const latestVersion = versions.sort(newestFirst)[0] || null;

  return {
    current: newerDraft || published || latestVersion,
    published,
  };
}
